/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAxisY = createReactComponent("outline", "axis-y", "IconAxisY", [["path", { "d": "M11 20h-.01", "key": "svg-0" }], ["path", { "d": "M15 20h-.01", "key": "svg-1" }], ["path", { "d": "M19 20h-.01", "key": "svg-2" }], ["path", { "d": "M4 7l3 -3l3 3", "key": "svg-3" }], ["path", { "d": "M7 20v-16", "key": "svg-4" }]]);

export { IconAxisY as default };
//# sourceMappingURL=IconAxisY.mjs.map
